export default "__VITE_ASSET__Cd54icVC__"